import { render } from "./InputCheckbox.vue?vue&type=template&id=40c6bb84&scoped=true"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"

import "./InputCheckbox.vue?vue&type=style&index=0&id=40c6bb84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c6bb84"]])

export default __exports__